import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../services/api";
import { NotificationsLevel } from "../../../lib/enums";
import { show } from "../../../notifications/notifications";
import { MenuItems, MenuItem, AddedTagResponse } from "../../@types";
import { formatTagNotificationMessage } from "../utils";
import { USER_TAGS_KEY } from "../queryKeys";

type tagManyRequestParams = {
  selectedTags: MenuItems;
  hashes: string[];
};

const useSetManyTags = () => {
  const tagMany = ({ selectedTags, hashes }: tagManyRequestParams) => {
    const transformedTags = selectedTags.map((item: MenuItem) => ({
      tag: item.value
    }));
    const tagManyRequestData = {
      tags: transformedTags,
      hashes
    };
    return api.tagMany(tagManyRequestData);
  };

  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: tagMany,
    onMutate: data => {
      if (data.hashes.length > 10) {
        show({
          level: NotificationsLevel.INFO,
          message: "Adding Tags..."
        });
      }
    },
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({ queryKey: [USER_TAGS_KEY] });
      const setManyAddedTags = data.added_tags.some(
        (item: AddedTagResponse) => item.added_tag !== undefined
      )
        ? data.added_tags
            .map((item: AddedTagResponse) => item.added_tag)
            .filter(
              (value: string, index: number, self: string[]) =>
                value && self.indexOf(value) === index
            )
        : [];
      const message = formatTagNotificationMessage(
        "Added tag",
        setManyAddedTags
      );
      show({
        level: NotificationsLevel.INFO,
        message
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "Something went wrong. Please try again."
      });
    }
  });

  return { mutate };
};

export default useSetManyTags;
